import * as React from "react";
import {cs}       from "@Common/react/chain-services";

const ID_DIGIT = "digit-0-9"

export const OfficeFilterBar = ({selections, sortedOffices, viewAllFn}) => cs(
    ["filteredLetters", (_, next) => next(
        sortedOffices?.map(office => (
            createIdFromOfficeName(office?.branchName ?? office?.officeName)
        ))
    )],
    ({filteredLetters}) => (
        <div className="filter-bar-div">
            <button
                className={`filter-bar-button`}
                onClick={() => { navigateToSearchStart() }}
                xd-qa-type="button"
                xd-qa-name="Top"
            >
                Top
            </button>
            <button
                className={`filter-bar-button`}
                onClick={() => {
                    viewAllFn()
                }}
                xd-qa-type="button"
                xd-qa-name="View All"
            >
                View All
            </button>
            <button
                className={
                    filteredLetters?.includes(ID_DIGIT)
                    ?
                    "filter-bar-button"
                    :
                    "filter-bar-button-disabled"
                }
                onClick={() => { navigateToId(ID_DIGIT) }}
                xd-qa-type="button"
                xd-qa-name="0-9"
            >
                0-9
            </button>
            {
                selections.map(selection => (
                    <button key={`filter-bar-button-${selection}`}
                        className={
                            filteredLetters?.includes(selection)
                            ?
                            "filter-bar-button"
                            :
                            "filter-bar-button-disabled"
                        }
                        onClick={() => { navigateToId(selection) }}
                        xd-qa-type="button"
                        xd-qa-name={selection}
                    >
                        {`${selection}`}
                    </button>
                ))
            }
        </div>
    )
)

export const createIdFromOfficeName = (officeName) => {
    if(0 === officeName.length) {
        return
    }

    const lower = officeName.charAt(0).toLowerCase()
    const upper = officeName.charAt(0).toUpperCase()
    if(lower !== upper) { // Only true for letters.
        return upper
    }

    return ID_DIGIT
}

export const navigateToSearchStart = () => {
    const HEADER_HEIGHT = 130
    window.scrollTo(0, HEADER_HEIGHT)
    // Remove any hash in URL.
    history.replaceState({}, document.title, window.location.href.split('#')[0])
}

const navigateToId = (id) => {
    const element = document.getElementById(id)
    if(element) {
        window.location.hash = `#${id}`
    }
}